import React, { useState } from 'react'
import { getAPIBaseURL, getSiteBaseURL } from '../services/helpers'
import { postData } from '../services/request'

const AdminLogin = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [btnState, setBtnState] = useState('Sign in')
  const [genError, setGenError] = useState('')

  const login = async () => {
    if(!username || !password){
      setGenError('Username and password are required')
      return
    }
    setBtnState('Loading...')
    const url = `${getAPIBaseURL()}/v1/admins/login`
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
    const form = new URLSearchParams()
    form.append('username', username)
    form.append('password', password)
    const requestResult = await postData(url, headers, form.toString())
    setBtnState('Sign in')
    if(requestResult.error == ''){
      if(requestResult.result.status === 200){
        localStorage.setItem('admin', JSON.stringify(requestResult.result.data.data))
        localStorage.setItem('user', JSON.stringify(requestResult.result.data.data))
        localStorage.setItem('settings', JSON.stringify(requestResult.result.data.settings))
        sessionStorage.setItem('active', true)           
        sessionStorage.setItem('admin-active', true)
        window.location.href = `${getSiteBaseURL()}/admin/app`
      }else{
        setGenError('Invalid credentials')
      }
    }else{
      setGenError(requestResult?.result?.data?.message || 'Login failed')
    }
  }

  return (
    <section class="bg-gray-50">
      <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <a class="flex items-center mb-6 text-2xl font-semibold">Employ Me Admin Login</a>
        <div class="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
          <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 class="text-xl font-bold leading-tight tracking-tight md:text-2xl">Admin Sign in</h1>
            <div class="space-y-4 md:space-y-6">
              {genError ? <div class="text-red-500 text-sm font-semibold">{genError}</div> : null}
              <div>
                <label class="block mb-2 text-sm font-medium">Username</label>
                <input value={username} onChange={(e)=>setUsername(e.target.value)} class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5" />
              </div>
              <div>
                <label class="block mb-2 text-sm font-medium">Password</label>
                <div class="relative">
                  <input
                    value={password}
                    onChange={(e)=>setPassword(e.target.value)}
                    type={showPassword ? "text" : "password"}
                    class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5 pr-10"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(prev => !prev)}
                    class="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-800"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? (
                      <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-5.523 0-10-4.03-10-7 0-.87.255-1.69.7-2.435m3.364-2.95C7.502 6.208 9.675 5 12 5c5.523 0 10 4.03 10 7 0 .87-.255 1.69-.7 2.435m-3.364 2.95A10.05 10.05 0 0112 19c-1.415 0-2.755-.283-3.975-.8" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4l16 16" />
                      </svg>
                    ) : (
                      <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
              <button onClick={login} class="w-full text-white bg-gray-800 hover:bg-gray-900 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center">{btnState}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AdminLogin

